<mat-nav-list>
    <mat-list-item>
      <h3 mat-dialog-title> Partnerstatus ändern </h3>
    </mat-list-item>
    <div *ngFor="let state of list">
      <mat-list-item role="listitem" *ngIf="this.data.businessEntityResource.state != state.value" (click)="changeState(state.value)">
        {{state.viewValue}}
      </mat-list-item>
    </div>
  </mat-nav-list>